export default __webpack_public_path__ + "static/media/complaint.a3bdb9ca.svg";